import axios from "axios";
import { apiClient, API_URL } from "./apiConfig";

// This file contains API calls related to QR codes for the GoodGlows application

export const leaderboardAPI = {
	// Get parties that are associated with a specific memberid
	getparties: async ({ memberid, contestid, zipcode }) => {
		return await apiClient.get(
			`/getparties/?memberid=${memberid}&contestid=${contestid}&zipcode=${zipcode}`
		);
	},

	// Get parties that are associated with a specific contest
	getContestParties: async ({ contestid }) => {
		return await apiClient.get(`/getparties/?contestid=${contestid}`);
	},

	// Get parties that are associated with a specific member
	getMyParties: async ({ memberid }) => {
		return await apiClient.get(`/getparties/?memberid=${memberid}`);
	},

	// Get contests that the member has participated in
	getContestsByMember: async ({ memberid }) => {
		return await apiClient.get(`/getcontests/?memberid=${memberid}`);
	},

	// Get contests that the member has participated in
	getContests: async () => {
		return await apiClient.get(`/getcontests/`);
	},

	// get parties based on zipcode
	getgeoparties: async ({ zipcode }) => {
		return await apiClient.get(`/getparties/?zipcode=${zipcode}`);
	},
};
